 const projects = [
  {
    title: "Modern Residential Complex",
    desc: "Supply and installation of high-performance aluminum window and door systems to meet the modern design and energy efficiency requirements of the project.",
    img: "/images/modern.jpg",
  },
  {
    title: "Office Building Exterior Cladding",
    desc: "Comprehensive material supply for the exterior of a commercial building, including glass facades and durable aluminum framing.",
    img: "/images/offices.jpg",
  },
  {
    title: "Residential Landscaping & Paving",
    desc: "Provided premium paving blocks for the full landscape design of a residential property, focusing on long-term durability and aesthetic appeal.",
    img: "/images/paving.jpg",
  },
    {
    title: "Eco-Friendly Office Park",
    desc: "Supplied over 15,000 brick tiles for a large-scale office park, contributing to its sustainable and modern design with a classic aesthetic.",
    img: "/images/office_park.jpg",
  },
  {
    title: "Urban Housing Development",
    desc: "Provided all concrete blocks for a multi-building urban housing project, ensuring structural integrity and a streamlined construction timeline.",
    img: "/images/urban_housing.jpg",
  },
  {
    title: "Retail Center Renovation",
    desc: "Custom-built and installed aluminum doors and windows for the full renovation of a retail center, enhancing natural light and security.",
    img: "/images/renovation.jpg",
  },
];


export default projects